export default __webpack_public_path__ + "static/media/back_driver_license.55f385de.png";